import { ArticleComponentCredits } from "@gik/blog/components/ArticleComponentCredits/ArticleComponentCredits";
import { useBemCN } from "@gik/core/utils/bemBlock";
import type { GalleryPhoto } from "@gik/ui-legacy/ImageGallery/ImageGallery";
import { ImageGallery } from "@gik/ui-legacy/ImageGallery/ImageGallery";
import React from "react";

export interface IGalleryWithLightboxProps {
	photos: GalleryPhoto[];
	caption: string;
	credit: string;
	creditLink: string;
}

const blockName = "gallery-with-lightbox";

export function GalleryWithLightbox({
	photos,
	caption,
	credit,
	creditLink,
}: IGalleryWithLightboxProps) {
	const bem = useBemCN(blockName);

	return (
		<div {...bem()}>
			<ImageGallery photos={photos} lightbox />
			<ArticleComponentCredits
				caption={caption}
				credit={credit}
				creditLink={creditLink}
			/>
		</div>
	);
}
